import React, { useState, useEffect } from 'react';

/*------------- IMPORTS FROM MATERIAL UI ------------------------------------*/
import Table from 'rsuite/Table';
import Pagination from 'rsuite/Pagination';
import Input from 'rsuite/Input';
import InputGroup from 'rsuite/InputGroup';
import Popover from 'rsuite/Popover';
import Dropdown from 'rsuite/Dropdown';
import Whisper from 'rsuite/Whisper';
import IconButton from 'rsuite/IconButton';
import ButtonToolbar from 'rsuite/ButtonToolbar';
import Loader from 'rsuite/Loader';
import Tag from 'rsuite/Tag';
import MoreIcon from '@rsuite/icons/legacy/More';
import ReloadIcon from '@rsuite/icons/Reload';
import SearchIcon from '@rsuite/icons/Search';
import AddOutlineIcon from '@rsuite/icons/AddOutline';

/*------------- OTHERS ------------------------------------------------------*/
import { useSelector, useDispatch } from 'react-redux';

/*------------- CUSTOM ------------------------------------------------------*/
import 'Components/Admin/User/table.css';
import { RequestUsersAsync, selectIsLoading, selectData, DeleteUserAsync } from 'slices/userSlice';
// import { openModalAction } from 'Components/Admin/User/Permissions/state/permissionAction';
import NewUserModal from 'Components/Admin/User/NewUser/NewUserModal';
import EmisoresUserModal from '../Emisores/EmisoresUserModal';
import SectionPanel from 'Components/Common/SectionPanel/SectionPanel';
import DelConfirmDialog from 'Components/Admin/User/Users/DeleteConfirmDialog';
import { Badge } from 'rsuite';
import { el } from '@faker-js/faker';

//const PermissionsUserModal = lazy(() => import('Components/Admin/User/Permissions/PermissionsUserModal'));

const { Column, Cell, HeaderCell } = Table;
const PAGE = 1;
const PAGE_SIZE = 11;

export default function TableUser() {
  const dispatch = useDispatch();
  const [openModalForm, setOpenModalForm] = useState(false);
  const [openEmisoresModalForm, setOpenEmisoresModalForm] = useState(false);
  const [openDelDialog, setOpenDelDialog] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [dataModel, setDataModel] = useState({});
  const [limit] = useState(PAGE_SIZE);
  const [page, setPage] = useState(PAGE);
  const [searchValue, setSearchValue] = useState('');
  const [filter, setFilter] = useState({
    search: '',
    numberPage: PAGE,
    sizePage: PAGE_SIZE,
  });

  //const permissionState = useSelector((state) => state.permission);
  const isLoading = useSelector(selectIsLoading);
  const usersData = useSelector(selectData);

  const handleEditUser = (data) => {
    setDataModel(data);
    setIsEdit(true);
    setOpenModalForm(true);
  };

  const handleAddUser = () => {
    setIsEdit(false);
    setDataModel(null);
    setOpenModalForm(true);
  };

  const handleSearch = () => {
    setFilter({ ...filter, search: searchValue, numberPage: 1 });
  };

  const handleDeleteUser = (userId) => {
    dispatch(DeleteUserAsync(userId)).then(() => {
      dispatch(RequestUsersAsync(filter));
      setOpenDelDialog(false);
    });
  };

  const handleChangePage = (value) => {
    setPage(value);
    setFilter({ ...filter, numberPage: value });
  };

  const handleRefreshTable = () => {
    setPage(1);
    setSearchValue('');
    setFilter({ ...filter, search: '', numberPage: 1 });
    dispatch(RequestUsersAsync({ ...filter, search: '', numberPage: 1 }));
  }

  const handleCloseEmisoresUser = () => {
    setOpenEmisoresModalForm(false);
    handleRefreshTable()
  }

  const ActionCell = ({ rowData, dataKey, ...props }) => {
    return (
      <Cell {...props} className="link-group">
        <Whisper
          placement="autoVerticalStart"
          trigger="click"
          speaker={(props, ref) => {
            const { className, left, top, onClose } = props;
            const handleSelect = (eventKey) => {
              onClose();
              switch (eventKey) {
                case 0:
                  handleEditUser(rowData);
                  break;
                case 1:
                  // dispatch(openModalAction(true));
                  break;
                case 2:
                  setDataModel(rowData);
                  setOpenDelDialog(true);
                  break;
                case 3:
                  setDataModel(rowData);
                  setOpenEmisoresModalForm(true);
                  break;
                default:
                  break;
              }
            };
            return (
              <Popover ref={ref} className={className} style={{ left, top }} full>
                <Dropdown.Menu onSelect={handleSelect}>
                  <Dropdown.Item eventKey={0}>Editar Usuario</Dropdown.Item>
                  <Dropdown.Item eventKey={2}>Eliminar Usuario</Dropdown.Item>
                  <Dropdown.Item eventKey={3}>Configurar Emisores</Dropdown.Item>
                  {/* <Dropdown.Item eventKey={1}>Permisos</Dropdown.Item> */}
                </Dropdown.Menu>
              </Popover>
            );
          }}
        >
          <IconButton appearance="subtle" icon={<MoreIcon />} />
        </Whisper>
      </Cell>
    );
  };

  const renderLoading = () => {
    return (
      <div>
        <Loader backdrop center content="Cargando" />
      </div>
    );
  };

  const RenderUserRol = (props) => {
    const { rowData } = props;
    if(rowData.rol == 100)
      return(<Tag color="green">Admin</Tag>)
    else if(rowData.rol == 101) {
      if(rowData.emisoresConfigurados == null)
        return  <Badge content="Configurar Emisores"><Tag color="blue">Colaborador</Tag></Badge>
      else if (rowData.emisoresConfigurados.length == 0)
        return  (<Badge content="Configurar Emisores"><Tag color="blue">Colaborador</Tag></Badge>)
      else return (<Tag color="blue">Colaborador</Tag>)
    } 
    else return (<Tag color='red'>Sin definir</Tag>)
  }

  useEffect(() => {
    dispatch(RequestUsersAsync(filter));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filter]);

  return (
    <SectionPanel
      title={
        <div className="table__hader">
          <h4>Administración de usuarios</h4>
          <div>
            <ButtonToolbar>
              <IconButton appearance="primary" icon={<ReloadIcon />} onClick={handleRefreshTable} />
              <IconButton appearance="primary" icon={<AddOutlineIcon />} onClick={handleAddUser}>
                Nuevo Usuario
              </IconButton>
            </ButtonToolbar>
          </div>
        </div>
      }
    >
      <div>
        <EmisoresUserModal isOpen={openEmisoresModalForm} handleClose={handleCloseEmisoresUser} usuario={dataModel ?? {}} />
        <NewUserModal isOpen={openModalForm} setOpen={setOpenModalForm} isEdit={isEdit} data={isEdit ? dataModel : null} />
        <DelConfirmDialog
          isOpen={openDelDialog}
          onConfirm={handleDeleteUser}
          onCancel={() => setOpenDelDialog(false)}
          data={dataModel ?? {}}
        />
        {/* <Suspense fallback={<div>loading...</div>}>{permissionState.modal.open && <PermissionsUserModal />}</Suspense> */}

        <div className="table__hader">
          <div>
            <InputGroup className="table__header-input">
              <Input placeholder="Buscar" value={searchValue} onChange={(value) => setSearchValue(value)}/>
              <InputGroup.Button onClick={handleSearch}>
                <SearchIcon />
              </InputGroup.Button>
            </InputGroup>
          </div>
        </div>
        <div className="table__body">
          <Table data={usersData.items} fillHeight loading={isLoading} renderLoading={renderLoading}>
            <Column flexGrow={1}>
              <HeaderCell>Nombre</HeaderCell>
              <Cell dataKey="nombre" />       
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Usuario</HeaderCell>
              <Cell dataKey="email" />
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>Email</HeaderCell>
              <Cell dataKey="email" />
            </Column>
            {/* <Column flexGrow={1}>
          <HeaderCell>Estatus</HeaderCell>
          <Cell>
            {rowData => (
              rowData.estatus === 100? (<Tag color="yellow">Pendiente</Tag>) : rowData.estatus === 101? <Tag color="green">Activo</Tag> : '-'
            )}
          </Cell>
        </Column> */}
            <Column flexGrow={1}>
              <HeaderCell>Rol</HeaderCell>
              <Cell>
                {(rowData) => 
                  <RenderUserRol rowData={rowData} />
                }
              </Cell>
            </Column>
            <Column flexGrow={1}>
              <HeaderCell>
                <MoreIcon />
              </HeaderCell>
              <ActionCell dataKey="id" />
            </Column>
          </Table>
        </div>
        <div style={{ padding: 20 }}>
          <Pagination first next total={usersData.recordsTotal} limit={limit} activePage={page} onChangePage={handleChangePage} />
        </div>
      </div>
    </SectionPanel>
  );

}